import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

interface ReferralRedirectProps {}

const ReferralRedirect: React.FC<ReferralRedirectProps> = () => {
  const { promoCode } = useParams<{ promoCode: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    const handleReferralRedirect = () => {
      if (promoCode) {
        // Сохраняем промокод в cookie на 15 дней
        const expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + 15);
        
        document.cookie = `referralPromoCode=${promoCode}; expires=${expirationDate.toUTCString()}; path=/; SameSite=Lax`;
        
        console.log(`Реферальный промокод ${promoCode} сохранен в cookie на 15 дней`);
      }
      
      // Перенаправляем на страницу регистрации
      navigate('/auth/register', { replace: true });
    };

    handleReferralRedirect();
  }, [promoCode, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-gray-900 dark:to-gray-800 flex items-center justify-center">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8 max-w-md w-full mx-4">
        <div className="text-center">
          <Loader2 className="w-8 h-8 animate-spin text-blue-600 mx-auto mb-4" />
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
            Обработка приглашения
          </h2>
          <p className="text-gray-600 dark:text-gray-400">
            Перенаправляем вас на страницу регистрации...
          </p>
          {promoCode && (
            <p className="text-sm text-blue-600 dark:text-blue-400 mt-2">
              Промокод: {promoCode}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReferralRedirect; 